module.exports = __webpack_public_path__ + "img/9788960174337.87618fd3.jpg";